import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

const firebaseConfig = {
  apiKey: 'AIzaSyDITp7vbYYEt3fHjcsS3sjJ7MEL81KfSjE',
  authDomain: 'cristianlessa.firebaseapp.com',
  projectId: 'cristianlessa',
  storageBucket: 'cristianlessa.firebasestorage.app',
  messagingSenderId: '897683508382',
  appId: '1:897683508382:web:3c3ced525536a8d2477f8f',
}

export const app = initializeApp(firebaseConfig)

export let appCheck = null

export function initAppCheckIfNeeded() {
  if (appCheck) return
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
  if (siteKey) {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true,
    })
  } else if (import.meta.env.PROD) {
    console.error('[firebase/config] VITE_RECAPTCHA_SITE_KEY not set — App Check disabled')
  }
}

export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)
export const functions = getFunctions(app, 'southamerica-east1')

if (import.meta.env.DEV) {
  // App Check debug token in dev — Firebase logs token to console on first run;
  // register it at Firebase Console → App Check → Apps → Manage debug tokens.
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true

  // Connect to local Firebase Emulators
  connectFirestoreEmulator(db, '127.0.0.1', 8088)
  connectAuthEmulator(auth, 'http://127.0.0.1:9099')
  connectStorageEmulator(storage, '127.0.0.1', 9199)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}
